import React from 'react';
import { Row, Radio } from 'antd';
import Box from '../../../../components/Box';
import Text from '../../../../components/Text';
import { Form } from 'antd';
import UploadCustomers from './components/UploadCustomers';
import SelectGroupCampaign from './components/SelectGroupCampaign';
import SearchCustomers from './components/SearchCustomers';
import GroupFilterSpecial from './components/GroupFilterSpecial';

export const typeCustomerValue = {
  ALL: 'all',
  UPLOAD_FILE: 'uploadFile',
  SELECT_GROUP_CAMPAIGN: 'selectGroupCampaign',
  CUSTOM: 'custom',
  GROUP_FILTER_SPECIAL: 'group_filter_special',
};

const FilterCustomers = () => {
  const form = Form.useFormInstance();

  const onChangeTypeCustomer = () => {
    form.setFieldsValue({ customers: [] });
  };

  return (
    <Box pb={1}>
      <Text variant='H5'>Group’s Campaign</Text>
      <Form.Item
        name={'typeCustomer'}
        rules={[
          {
            required: true,
            message: 'Choose customer!',
          },
        ]}
      >
        <Radio.Group onChange={onChangeTypeCustomer}>
          <Row style={{ marginTop: '10px', gap: 24 }}>
            <Radio value={typeCustomerValue.ALL}>All</Radio>
            <Radio value={typeCustomerValue.UPLOAD_FILE}>Upload File</Radio>
            <Radio value={typeCustomerValue.SELECT_GROUP_CAMPAIGN}>Group’s Campaign</Radio>
            <Radio value={typeCustomerValue.CUSTOM}>Custom</Radio>
            <Radio value={typeCustomerValue.GROUP_FILTER_SPECIAL}>Group Filter Special</Radio>
          </Row>
        </Radio.Group>
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const typeCustomer = getFieldValue('typeCustomer');

          if (typeCustomer === typeCustomerValue.UPLOAD_FILE) {
            return <UploadCustomers />;
          }

          if (typeCustomer === typeCustomerValue.SELECT_GROUP_CAMPAIGN) {
            return <SelectGroupCampaign />;
          }

          if (typeCustomer === typeCustomerValue.CUSTOM) {
            return <SearchCustomers />;
          }

          if (typeCustomer === typeCustomerValue.GROUP_FILTER_SPECIAL) {
            return <GroupFilterSpecial />;
          }

          return null;
        }}
      </Form.Item>
    </Box>
  );
};

export default FilterCustomers;
